<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn color="primary" @click="list()" block>
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Origem</th>
          <th>Destino</th>
          <th>Servidor</th>
          <th>Início</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.source }}</td>
          <td>{{ item.number }}</td>
          <td>{{ item.server }}</td>
          <td>{{ item.time | formatDate}} {{ item.time | formatTime}}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    current: null
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/channel", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.current = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    }
  }
};
</script>